var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "代理列表", name: "agent" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "mb14",
                      attrs: { inline: "", size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户UID" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "用户UID", clearable: "" },
                            model: {
                              value: _vm.agentSearch.uid,
                              callback: function ($$v) {
                                _vm.$set(_vm.agentSearch, "uid", $$v)
                              },
                              expression: "agentSearch.uid",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "160px" },
                            attrs: { placeholder: "用户手机号", clearable: "" },
                            model: {
                              value: _vm.agentSearch.uidPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.agentSearch, "uidPhone", $$v)
                              },
                              expression: "agentSearch.uidPhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getAgentList(1)
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.agentSearch.uid = ""
                                  _vm.agentSearch.uidPhone = ""
                                  _vm.getAgentList(1)
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.agentLoading,
                          expression: "agentLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.agentList.data,
                        size: "mini",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", label: "序号", width: "60" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "uid", label: "用户UID", width: "80" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "nickname",
                          label: "用户昵称",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "phone", label: "手机号", width: "120" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "directCount",
                          label: "直推人数",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "teamConsumeTotal",
                          label: "团队消费(元)",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "achieveTime",
                          label: "升级时间",
                          "min-width": "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "创建时间",
                          "min-width": "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "120", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title:
                                        "确定取消该用户的代理身份？取消后需重新达标才能恢复",
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.handleCancel(scope.row.uid)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: ["admin:kx:agent:cancel"],
                                            expression:
                                              "['admin:kx:agent:cancel']",
                                          },
                                        ],
                                        staticStyle: { color: "#f56c6c" },
                                        attrs: {
                                          slot: "reference",
                                          type: "text",
                                          size: "mini",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("取消代理")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "page-sizes": [20, 40, 60],
                          "page-size": _vm.agentSearch.limit,
                          "current-page": _vm.agentSearch.page,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.agentList.total,
                          background: "",
                        },
                        on: {
                          "size-change": _vm.handleAgentSizeChange,
                          "current-change": _vm.agentPageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "团队业绩", name: "performance" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "mb14",
                      attrs: { inline: "", size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "代理UID" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "150px" },
                            attrs: { placeholder: "代理UID", clearable: "" },
                            model: {
                              value: _vm.perfSearch.uid,
                              callback: function ($$v) {
                                _vm.$set(_vm.perfSearch, "uid", $$v)
                              },
                              expression: "perfSearch.uid",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "160px" },
                            attrs: { placeholder: "用户手机号", clearable: "" },
                            model: {
                              value: _vm.perfSearch.uidPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.perfSearch, "uidPhone", $$v)
                              },
                              expression: "perfSearch.uidPhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年月" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "month",
                              placeholder: "选择月份",
                              "value-format": "yyyy-MM",
                            },
                            model: {
                              value: _vm.perfSearch.yearMonth,
                              callback: function ($$v) {
                                _vm.$set(_vm.perfSearch, "yearMonth", $$v)
                              },
                              expression: "perfSearch.yearMonth",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getPerformanceList(1)
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["admin:kx:agent:performance:export"],
                                  expression:
                                    "['admin:kx:agent:performance:export']",
                                },
                              ],
                              on: { click: _vm.handleExport },
                            },
                            [_vm._v("导出")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.perfLoading,
                          expression: "perfLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.perfList.data,
                        size: "mini",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", label: "序号", width: "60" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "uid", label: "代理UID", width: "80" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "nickname",
                          label: "用户昵称",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "phone", label: "手机号", width: "120" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "yearMonth",
                          label: "年月",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "teamConsumeAmount",
                          label: "团队消费总额(元)",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "teamOrderCount",
                          label: "团队订单数",
                          width: "110",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "directCount",
                          label: "直推下级人数",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "newDirectCount",
                          label: "本月新增直推人数",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "personalBonus",
                          label: "本月个人直推奖合计",
                          width: "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "创建时间",
                          "min-width": "150",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "page-sizes": [20, 40, 60],
                          "page-size": _vm.perfSearch.limit,
                          "current-page": _vm.perfSearch.page,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.perfList.total,
                          background: "",
                        },
                        on: {
                          "size-change": _vm.handlePerfSizeChange,
                          "current-change": _vm.perfPageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }